import { Injectable } from '@angular/core';
import { BaseControl, Textbox } from '@app/shared';
import { Validators } from '@angular/forms';
import { Helps } from '@app/shared/models/helps.model';

@Injectable()
export class HelpsFormService {
  constructor() { }

  
  /**
   * Construye y retorna el formulario para modificar una ayuda
   *
   * @param {Helps} [help]
   * @return {*}  {BaseControl<any>[]}
   * @memberof HelpsFormService
   */
  getFormHelp(help?: Helps
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        value: help && help.nombre ? help.nombre : null,
        label: 'Nombre',
        placeholder: 'Ingrese un nombre',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'url',
        value: help && help.url ? help.url : null,
        label: 'Url',
        placeholder: 'Ingrese un url',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'activo',
        type: 'checkbox',
        label: 'Activo',
        class: {
          container: ['form-check', 'form-check-inline']
        },
        value: help && help.activo ? help.activo : false,
        order: 3,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management_helps/helps-component/shared/helps.form.service.ts